import OneTimeOrderConfirmation from './OneTimeOrderConfirmation';

export default OneTimeOrderConfirmation;
